
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 74 74"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","width":"142.9%","height":"142.9%","x":"-21.4%","y":"-21.4%","filterUnits":"objectBoundingBox"}},[_c('feMerge',[_c('feMergeNode',{attrs:{"in":"shadowMatrixOuter1"}}),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})])])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","filter":"url(#a)","transform":"translate(9 9)"}},[_c('circle',{attrs:{"cx":"28","cy":"28","r":"28","fill":"#FFF"}}),_c('path',{attrs:{"fill":"#FE5E4A","d":"M28 0c15.464 0 28 12.536 28 28S43.464 56 28 56 0 43.464 0 28 12.536 0 28 0zm0 18c-.92 0-1.667.746-1.667 1.667v6.666h-6.666a1.667 1.667 0 000 3.334h6.666v6.666a1.667 1.667 0 003.334 0v-6.666h6.666a1.667 1.667 0 000-3.334h-6.666v-6.666c0-.92-.747-1.667-1.667-1.667z"}})])])
          )
        }
      }
    